const barcodeGenerator = [
    {
        selector: '[data-barcode-generator]',
        path: { filename: 'barcodeGeneratorInit' },
    },
];

export { barcodeGenerator };
